import _ from 'lodash';

const generateThumbnail = _.memoize(function (src) {
    if (src instanceof File) src = URL.createObjectURL(src);
    return new Promise((resolve, reject) => {
        let video = document.createElement('video'),
            canvas = document.createElement('canvas');
        video.addEventListener('loadedmetadata', () => {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
        });
        video.addEventListener('timeupdate', () => {
            let ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
            let dataUrl = canvas.toDataURL();
            if (dataUrl.length > 10) {
                resolve(dataUrl);
            } else {
                reject();
            }
        });
        video.addEventListener('error', reject);
        video.setAttribute('crossOrigin', 'anonymous');
        video.setAttribute('src', src);
        video.currentTime = 0.1;
    });
});

export default generateThumbnail;
